import { render, staticRenderFns } from "./DashboardMarketing.vue?vue&type=template&id=6be97fd2&scoped=true"
import script from "./DashboardMarketing.vue?vue&type=script&lang=js"
export * from "./DashboardMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be97fd2",
  null
  
)

export default component.exports